<div class="flex justify-center items-center gap-x-1 max-w-4xl bg-[#fce4e4] rounded-3xl">
  <mat-icon color="warn" aria-label="Info icon" class="scale-75 ml-2">info</mat-icon>
  <span class="mat-warn-color text-sm font-light py-2 -mr-2">{{data}}</span>
  <button mat-icon-button color="warn" (click)="onCloseClicked()" aria-label="Close icon" class="scale-75">
    <mat-icon>close</mat-icon>
  </button>
</div>
